function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.27498 12.775C9.56748 12.4825 9.56748 12.01 9.27498 11.7175L7.24998 9.6925L6.19248 10.75L8.21748 12.775C8.50998 13.0675 8.98998 13.0675 9.27498 12.775ZM2.53248 4H4.24998V8.1925L0.717483 11.7175C0.424983 12.01 0.424983 12.4825 0.717483 12.775C1.00998 13.0675 1.48248 13.0675 1.77498 12.775L5.30748 9.25C5.59248 8.965 5.74998 8.59 5.74998 8.1925V4H7.46748C7.80498 4 7.96998 3.595 7.72998 3.3625L5.26248 0.895001C5.11248 0.745001 4.87998 0.745001 4.72998 0.895001L2.26248 3.3625C2.02998 3.595 2.19498 4 2.53248 4Z",
  fill: "white"
});

function SvgMergeIconSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 13,
    viewBox: "0 0 10 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMergeIconSmall);
export default __webpack_public_path__ + "static/media/merge_icon_small.9205ee63.svg";
export { ForwardRef as ReactComponent };